import { ImageCarouselEvent } from '@naturehouse/design-system/components/organisms/image-carousel/ImageCarousel';
import type Swiper from 'swiper/types/swiper-class';

export const handleNextButtonClick = ({ el }: Swiper): void => {
    el.dispatchEvent(new Event(ImageCarouselEvent.NEXT_BUTTON_CLICK));
};

export const handlePrevButtonClick = ({ el }: Swiper): void => {
    el.dispatchEvent(new Event(ImageCarouselEvent.PREV_BUTTON_CLICK));
};

export const handleTouchEnd = ({ el, swipeDirection }: Swiper): void => {
    if (swipeDirection === 'next') {
        el.dispatchEvent(new Event(ImageCarouselEvent.NEXT_SWIPE_ACTION));
        return;
    }

    el.dispatchEvent(new Event(ImageCarouselEvent.PREV_SWIPE_ACTION));
};
